import React from 'react';

import Data from 'data';
import { _F } from 'data';

import { getIconPath } from 'common';
import { formatNumber } from 'utils/format';

export const ColorNumber = ({ value }) => <span className={`la-number-${Math.floor(Math.log10(value))}`}>{formatNumber(value, 0, 1000)}</span>;

const townItems = new Set([33200, 33900, 33400, 60901, 60904, 60905, 60800, 73100, 33300]);
const giftItems = new Set([70500, 70501, 70502]);

export function ItemIcon({ item, upgrade }) {
  const upgradeData = upgrade && Data.itemQuality[`${item.quality}#${100 + upgrade}`];
  const appearance = upgradeData?.evolutionAppearance && Data.evolutionAppearance?.[`${upgradeData.evolutionAppearance}#${item.category}`];
  return (
    <div className="lap-item-icon" style={{backgroundImage: `url(${getIconPath(appearance || item.icon)}`}}>
      {item.gem && (
        <span className="lap-item-gem-level">
          {_F('sys.gem.common_slot_gem_level', item.gem.level)}
        </span>
      )}
      {(item.category === 30801 || item.category === 30802) && (
        <span className="lap-item-collectible"/>
      )}
      {(item.category === 71700 || item.category === 71701) && (
        <span className="lap-item-island"/>
      )}
      {townItems.has(item.category) && (
        <span className="lap-item-town"/>
      )}
      {giftItems.has(item.category) && (
        <span className="lap-item-gift"/>
      )}
    </div>
  );
}
